import { render } from "./FunerariaView.vue?vue&type=template&id=0281bcea"
import script from "./FunerariaView.vue?vue&type=script&lang=js"
export * from "./FunerariaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__